import React from "react";
import { connect } from "react-redux";

import { ProgressSpinner } from 'primereact/progressspinner';

import '../../css/loading-display.css'

// destructure props so we only get the things we need
// error display in it's own component because it needs to connect to the store but
// issues are caused when that is attempted in the App container

// isLoading flag should be set using promises in places where the components are doing something
// i.e. componentDiDMount loading data
const LoadingDisplay = ({ app }) =>{
    return (app.isLoading && <ProgressSpinner />)
}

const mapStateToProps=(state)=>{
    return state
}

export default connect (mapStateToProps)(LoadingDisplay);


// WEBPACK FOOTER //
// ./src/components/common/LoadingDisplay.js